import React, { useEffect, useState } from 'react';

import './styles.css';

import close from '../../../assets/images/close.svg';
import statistics from '../../../assets/images/statistics.svg';
import trophy3 from '../../../assets/images/trophy3.svg';
import pin4 from '../../../assets/images/pin4.svg';
import calendar2 from '../../../assets/images/calendar2.svg';
import moment from "moment";
import 'moment/locale/pt-br';
import api from '../../../services/api';

export const ModalSales = ({ handleClose, title, id, type, totalVendas, filter, plantoesName, date }) => {
  const [vendas, setVendas] = useState([]);

  useEffect(() => {
    getVendas();
  }, []);

  const getVendas = async () => {
    const { data } = await api.get(`${type}/${id}/vendas`, {
      params: filter
    });
    setVendas(data.vendas);
  }

  return (
    <div className="dash-modal">
      <div className="dash-modal-content lg">
        <button className="btn-close" onClick={() => handleClose()}><img src={close} /></button>
        <div className="dash-modal-header header-modal-pages">
          <div>
            <img src={statistics} />
            <h1>Estatísticas</h1>
          </div>
          <div className="data-about">
            <img src={trophy3} />
            <h1 style={{ color: "#02C39A" }}>{totalVendas}</h1>
            <p>{title}</p>
          </div>
        </div>
        <div className="box-modal-gray">
          <div className="box-gray-modals">
            <img src={pin4} />
            <p>{plantoesName}</p>
          </div>
          <div className="box-gray-modals">
            <img src={calendar2} />
            <p>{date}</p>
          </div>
        </div>
        <div className="dash-modal-body">
          <div className="box-card h-full">
            <div className="box-card-noPadding box-table-shifts">
              <table className="table-dash">
                <thead>
                  <tr className="light-blue">
                    <th>Dia</th>
                    <th>Produto</th>
                    {type !== "corretores" &&
                      <th>Corretor</th>
                    }
                    <th>Unidade</th>
                  </tr>
                </thead>
                <tbody>
                  {vendas.map((venda, key) => (
                    <tr key={key}>
                      <td>{moment(venda.data).format("DD/MM/YYYY")}</td>
                      <td>{venda.plantao.imovel_nome}</td>
                      {type !== "corretores" &&
                        <td>
                          {venda.tipo === 'gerente' && venda.gerente?.apelido}
                          {venda.tipo !== 'gerente' && venda.corretor?.apelido}

                          {venda.tipo === 'gerente' &&
                            <>
                              <br /><span className="tag-manager">GERENTE</span>
                            </>
                          }
                        </td>
                      }
                      <td>{venda.unidade}</td>
                    </tr>
                  ))}

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="dash-modal-footer">

        </div>
      </div>
    </div>
  );

}

export default ModalSales;